// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SalarySlipForm.css */

/* Base styles */
/* .MuiPaper-root {
  border-radius: 12px !important;
} */

.MuiButton-contained {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

.MuiButton-outlined {
  text-transform: none !important;
}

/* Form styles */
.salary-slip-form-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Employee dropdown */
.MuiMenuItem-root {
  border-bottom: 1px solid var(--gray-200);
}

.MuiMenuItem-root:last-child {
  border-bottom: none;
}

.MuiMenuItem-root:hover {
  background-color: var(--gray-50) !important;
}

/* Salary slip details */
.salary-slip-details {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .MuiGrid-container {
    flex-direction: column;
  }
  
  .MuiGrid-item {
    width: 100%;
    max-width: 100%;
  }
}

/* Animation for form elements */
.MuiTextField-root, .MuiFormControl-root, .MuiButton-root {
  transition: all 0.3s ease;
}

/* Hover effects */
.MuiButton-contained:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Focus styles */
.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--primary-500) !important;
  border-width: 2px !important;
}

/* Error message */
.error-message {
  color: var(--error);
  background-color: #fdecea;
  padding: 8px 16px;
  border-radius: 4px;
  margin-top: 16px;
  font-size: 0.875rem;
}

/* Salary summary highlight */
.salary-summary {
  background-color: var(--gray-50);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

/* Download button */
.download-button {
  margin-top: 16px;
  width: 100%;
}

/* Responsive typography */
@media (max-width: 600px) {
  .MuiTypography-h4 {
    font-size: 1.8rem !important;
  }
  
  .MuiTypography-h6 {
    font-size: 1.2rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SalarySlip/SalarySlipForm.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,gBAAgB;AAChB;;GAEG;;AAEH;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* SalarySlipForm.css */\n\n/* Base styles */\n/* .MuiPaper-root {\n  border-radius: 12px !important;\n} */\n\n.MuiButton-contained {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.5px !important;\n}\n\n.MuiButton-outlined {\n  text-transform: none !important;\n}\n\n/* Form styles */\n.salary-slip-form-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Employee dropdown */\n.MuiMenuItem-root {\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.MuiMenuItem-root:last-child {\n  border-bottom: none;\n}\n\n.MuiMenuItem-root:hover {\n  background-color: var(--gray-50) !important;\n}\n\n/* Salary slip details */\n.salary-slip-details {\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 900px) {\n  .MuiGrid-container {\n    flex-direction: column;\n  }\n  \n  .MuiGrid-item {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* Animation for form elements */\n.MuiTextField-root, .MuiFormControl-root, .MuiButton-root {\n  transition: all 0.3s ease;\n}\n\n/* Hover effects */\n.MuiButton-contained:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* Focus styles */\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--primary-500) !important;\n  border-width: 2px !important;\n}\n\n/* Error message */\n.error-message {\n  color: var(--error);\n  background-color: #fdecea;\n  padding: 8px 16px;\n  border-radius: 4px;\n  margin-top: 16px;\n  font-size: 0.875rem;\n}\n\n/* Salary summary highlight */\n.salary-summary {\n  background-color: var(--gray-50);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n/* Download button */\n.download-button {\n  margin-top: 16px;\n  width: 100%;\n}\n\n/* Responsive typography */\n@media (max-width: 600px) {\n  .MuiTypography-h4 {\n    font-size: 1.8rem !important;\n  }\n  \n  .MuiTypography-h6 {\n    font-size: 1.2rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
